module.exports = __webpack_public_path__ + "img/u2118.66447db7.png";